<template>
  <v-container fluid>
      <div class="scroll-container">
        <v-card class="my-1" tile v-for="(item, index) in listNotify" :key="index" cols="12">
          <v-card-text class="py-2">
            <v-card-title class="pa-0">
              <div class="notify-content">
                <h3 class="body-2">{{item.title}}</h3>
                <p class="mb-0">{{ item.content }}</p>
              </div>
              <div class="notify-time">
                {{item.createdTime | formatDateTime}}
              </div>
            </v-card-title>
          </v-card-text>
        </v-card>
         
      </div>
      
      <v-form ref="form" lazy-validation class="white v-card mt-3">
        <v-layout row wrap align-center>
          <v-flex xs12 sm9 md10 class="px-3">
            <v-text-field
              ref="title"
              label="Tiêu đề"
              v-model="title"
              :rules="[validate.required]"
              class="pb-2"
            ></v-text-field>
            <v-text-field
              ref="content"
              label="Nội dung"
              v-model="content"
              :rules="[validate.required]"
              class="pb-2"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm3 md2 class="text-xs-right px-3">
            <v-btn block color="primary" @click="onSendNotification" :loading="loadingBtn">Gửi <v-icon small right dark>send</v-icon></v-btn>
          </v-flex>
        </v-layout>
      </v-form>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex';
import validate from '../utils/validate';
import moment from 'moment';

export default {

  filters: {
    formatDateTime (val) {
      if (!val) return val;
      return moment(val).add(7, 'hours').format('DD-MM-YYYY, HH:mm');
    }
  },

  data: () => ({
    title: '',
    content: '',
    validate: validate,
    loadingBtn: false,
    listNotify: [],
    pagination: {
      applicationId: 'sc.apps.vietmap.vn',
      page: 1,
      pageSize: 100
    },
  }),

  async created () {
    await this.getListNotification();
    this.scrollContainer(); 
  },

  methods: {
    ...mapActions(['SendMessage', 'GetNotifications']),

    async onSendNotification () {
      if (this.$refs.form.validate()) {
        let data = {
          title: this.title,
          content: this.content,
          applicationId: 'sc.apps.vietmap.vn',
          link: 'https://outlook.office.com/webhook/a44781f6-2daa-46a4-93f3-9fc4fee5f443@fc2e159c-528b-4132-b3c0-f43226646ad7/IncomingWebhook/ede0aa999f2a43ccb83a286c56a3584d/6aa6cbe2-76cc-425e-af60-11de61449e83'
        };

        this.loadingBtn = true;
        let res = await this.SendMessage(data).catch(() => {
          return false;
        });
        
        this.loadingBtn = false;

        if (res) {
          window.getApp.showMessage('Gửi thông báo thành công.');
          
          this.$refs.form.reset();
          await this.getListNotification();
          this.scrollContainer();
        }
        else { window.getApp.showMessage('Gửi thông báo thất bại.', 'error') }
      }
    },

    async getListNotification () {
      let res = await this.GetNotifications(this.pagination).catch(_ => {
        return null; 
      });

      this.listNotify = res && res.notifications.reverse(); 
    },

    scrollContainer () {
      const container = document.querySelector('.scroll-container');
      container.scrollTop = 58 * this.listNotify.length;
    }

  },
};
</script>

<style scoped>
.notify-content{
  width: calc(100% - 120px);
  padding-right: 30px;
}

.scroll-container{
  height: calc(100vh - 282px);
  overflow-y: auto;
}
/*Width*/
.scroll-container::-webkit-scrollbar {
  width: 10px;
}
/* Track */
.scroll-container::-webkit-scrollbar-track {
  background: #f1f1f1; 
}
/* Handle */
.scroll-container::-webkit-scrollbar-thumb {
  background: #888; 
  border-radius: 4px;
}
/* Handle on hover */
.scroll-container::-webkit-scrollbar-thumb:hover {
  background: #555; 
}

@media (max-width: 599px) {
  .scroll-container{
    height: calc(100vh - 320px);
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/SendNotify.vue